import ErrorIcon from '@mui/icons-material/Error'
import SendIcon from '@mui/icons-material/Send'
import { Box, CircularProgress, Grid, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { requestWithUserAuth } from '../../../api/auth'
import { createYap } from '../../../api/yaps'
import { setConnectionError } from '../../../state/error'
import { setCreateDisabled, setCreatingYap, setDraftedMessage, setValidationError } from '../../../state/yaps'
import { useThemeMode } from '../../../theme'
import { isDefined } from '../../../utils'
import { Button, CountDown, ErrorModal } from '../widgets'

const getThemeSx = (palette) => ({
  position: 'sticky',
  zIndex: 100,
  height: '50px',
  top: 0,
  background: palette.headerTransparentColor,
  '& .companion-yaps-send-input-wrapper': {
    padding: '10px',
    height: '50px',
    '& input': {
      padding: '5px'
    }
  },
  '& .companion-yaps-send-button-wrapper': {
    lineHeight: '50px',
    height: '50px',
    textAlign: 'center',
    '& .MuiButtonBase-root': {
    },
    '& .companion-yaps-send-progress-wrapper': {
      padding: '5px',
      height: '50px',
      display: 'inline-block'
    }
  },
  '& .MuiCircularProgress-root': {
    color: 'white'
  },
  '& .companion-yaps-send-input': {
    width: '100%',
    height: '30px',
    '& .Mui-focused': {
      color: palette.paperColor
    },
    '& .Mui-error': {
      color: palette.errorColor
    }
  },
  '& .companion-countdown': {
    marginTop: '5px',
    display: 'inline-block',
    '& span': {
      lineHeight: '20px'
    }
  }
})

export const Send = (props) => {
  const { auth, config, language, error, created, draftedMessage, validationError } = props
  const creating = props.creating ?? false
  const createDisabled = props.createDisabled ?? false
  const dispatch = useDispatch()
  const translation = useTranslation()
  const { t } = translation.i18n
  const { palette } = useThemeMode()
  const themeSX = getThemeSx(palette)

  const sendEvent = () => {
    if (isDefined(draftedMessage)) {
      dispatch(setCreatingYap({ creating: true }))
      requestWithUserAuth(config, auth, (auth) =>
        createYap(config, auth, draftedMessage, language)
      )
    } else {
      dispatch(setValidationError({ validationError: 'empty-yap-validation-error' }))
    }
  }

  const changeEvent = (value) => {
    dispatch(setDraftedMessage({ draftedMessage: value }))
    if (isDefined(value.replace(/\s/g, ''))) {
      dispatch(setValidationError({ validationError: '' }))
    } else {
      dispatch(setValidationError({ validationError: 'empty-yap-validation-error' }))
    }
  }

  const difference = isDefined(created) ? Math.floor((new Date().getTime() - created) / 1000) : 100000

  let sendControl
  const disabled = createDisabled && difference < 30
  if (disabled) {
    const remaining = 30 - difference
    sendControl = <CountDown remaining={remaining} onTrigger={ () => dispatch(setCreateDisabled({ createDisabled: false })) }/>
  } else {
    const progress = <Box className="companion-yaps-send-progress-wrapper"><CircularProgress /></Box>
    sendControl = creating ? progress : <Button disabled={ isDefined(validationError)} onClick={() => sendEvent()} variant="invert-contained" icon={<SendIcon />} />
  }
  const closeModalHandler = () => {
    dispatch(setConnectionError({ error: false, detail: '' }))
  }
  const modalProps = {
    label: error.errorDetail?.detail,
    open: error.connectionError,
    onClose: () => closeModalHandler(),
    icon: (<ErrorIcon />)
  }

  const label = isDefined(validationError) ? t(validationError) : t('new-yap')

  const textFieldProps = {
    onChange: (e) => changeEvent(e.target.value),
    disabled,
    label,
    size: 'small',
    margin: 'none',
    value: draftedMessage
  }

  const textFieldPropsWithValidation = isDefined(validationError) ? { error: true, ...textFieldProps } : textFieldProps

  return (
    <Grid container className="companion-yaps-send" sx={themeSX}>
      <Grid xs={10} item className="companion-yaps-send-input-wrapper" >
        <TextField className="companion-yaps-send-input" {...textFieldPropsWithValidation}/>
      </Grid>
      <Grid xs={2} item className="companion-yaps-send-button-wrapper" >
        <ErrorModal {...modalProps}/>
        {sendControl}
      </Grid>
    </Grid>
  )
}
